<template>
    <div class="animated fadeIn">
        <model-form v-if="addModelMode" v-bind:model="newModel" v-bind:mode="modelInputMode"></model-form>
        <font-form v-if="addFontMode" v-bind:font="newFont" v-bind:mode="fontInputMode"></font-form>
        <manufacturer-form v-if="showManufacturerForm" v-bind:manufacturer="manufacturerObj" v-bind:mode="manufacturerInputMode"></manufacturer-form>
        <b-tabs v-if="!anyAddMode">
            <b-tab title="Models" active>
                <div v-if="!addModelMode && !editModelMode" class="viewMode">
                    <b-row>
                        <b-col cols="12">
                            <h1>{{manufacturerName}} Models</h1>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="!addModelMode" class="addModelMode">
                    <b-row>
                        <b-col sm="12">
                            <b-card>
                                <div slot="header">
                                    <strong>Model List</strong>
                                </div>
                                <div v-if="!modelsLoaded" class="form-container">
                                    <LoadingSpinner />
                                </div>
                                <div v-if="modelsLoaded" class="form-container">
                                    <b-row v-if="!isUserReadOnly">
                                        <b-col cols="12" sm="12" md="6">
                                            <p>
                                                <b-button v-on:click="addModel" variant="primary">
                                                    <i class="fa fa-plus"></i>&nbsp;Add Model
                                                </b-button>
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="3">
                                            <b-form-group>
                                                <label for="modelTableFilter">Filter</label>
                                                <b-form-input v-model="modelTableFilter" type="text" id="modelTableFilter"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <div>
                                                <b-table
                                                    id="model-data-table"
                                                    class="datalist-table"
                                                    selectable
                                                    hover
                                                    bordered
                                                    select-mode="single"
                                                    :items="models"
                                                    :fields="modelTableFields"
                                                    :filter="modelTableFilter"
                                                    :per-page="modelTablePerPage"
                                                    :current-page="modelTableCurrentPage"
                                                    @row-clicked="modelRowSelected"
                                                    responsive="sm"
                                                    >
                                                </b-table>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6" class="my-1">
                                            <b-pagination
                                            v-model="modelTableCurrentPage"
                                            :total-rows="modelTableTotalRows"
                                            :per-page="modelTablePerPage"
                                            class="my-0"
                                            ></b-pagination>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-tab>
            <b-tab title="Fonts">
                <div v-if="!addFontMode && !editFontMode" class="viewMode">
                    <b-row>
                        <b-col cols="12">
                            <h1>{{manufacturerName}} Fonts</h1>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="!addFontMode" class="addMode">
                    <b-row>
                        <b-col sm="12">
                            <b-card>
                                <div slot="header">
                                    <strong>Font List</strong>
                                </div>
                                <div v-if="!modelsLoaded" class="form-container">
                                    <LoadingSpinner />
                                </div>
                                <div v-if="modelsLoaded" class="form-container">
                                    <b-row v-if="!isUserReadOnly">
                                        <b-col cols="12" sm="12" md="6">
                                            <p>
                                                <b-button v-on:click="addFont" variant="primary">
                                                    <i class="fa fa-plus"></i>&nbsp;Add Font
                                                </b-button>
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <!--
                                    <b-row>
                                        <b-col sm="3">
                                            <b-form-group>
                                                <label for="fontTableFilter">Filter</label>
                                                <b-form-input v-model="fontTableFilter" type="text" id="fontTableFilter"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <div>
                                                <b-table
                                                    id="font-data-table"
                                                    class="datalist-table"
                                                    selectable
                                                    hover
                                                    bordered
                                                    select-mode="single"
                                                    :items="fonts"
                                                    :fields="fontTableFields"
                                                    :filter="fontTableFilter"
                                                    :per-page="fontTablePerPage"
                                                    :current-page="fontTableCurrentPage"
                                                    @row-clicked="fontRowSelected"
                                                    responsive="sm"
                                                    >
                                                </b-table>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6" class="my-1">
                                            <b-pagination
                                            v-model="fontTableCurrentPage"
                                            :total-rows="fontTableTotalRows"
                                            :per-page="fontTablePerPage"
                                            class="my-0"
                                            ></b-pagination>
                                        </b-col>
                                    </b-row>
                                    -->
                                    <div class="form-container">
                                        <b-row>
                                            <b-col sm="2">
                                                <div class="mb-3">
                                                    <strong>Added?</strong>
                                                </div>
                                            </b-col>
                                            <b-col sm="5">
                                                <div class="mb-3">
                                                    <strong>Font Name</strong>
                                                </div>
                                            </b-col>
                                            <b-col sm="5">
                                                <div class="mb-3">
                                                    <strong>Font Slug</strong>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row v-for="font in fonts" v-bind:key="font.id" class="output-row">
                                            <b-col sm="2">
                                                <b-button 
                                                    variant="outline-primary" 
                                                    :pressed.sync="font.isIncluded"
                                                    v-on:click="fontSelected(font)"
                                                    block>
                                                    <span v-if="font.isIncluded">Yes</span><span v-else>No</span>
                                                </b-button>
                                            </b-col>
                                            <b-col sm="5">
                                                <b-input-group>
                                                    <b-form-input
                                                    v-model="font.font_name"
                                                    type="text"
                                                    class="form-control"
                                                    :id="'font-' + font.id + '-' + font.font_name"
                                                    readonly
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col sm="5">
                                                <b-input-group>
                                                    <b-form-input
                                                    v-model="font.font_name_slug"
                                                    type="text"
                                                    class="form-control"
                                                    :id="'font-' + font.id + '-' + font.font_name_slug"
                                                    readonly
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import cTable from '../../components/table/Table';
import ManufacturerForm from '../../components/forms/show-plates/ManufacturerForm';
import ModelForm from '../../components/forms/show-plates/ModelForm';
import FontForm from '../../components/forms/show-plates/FontForm';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}

const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user != null) {
            resolve(user);
        }
        else {
            reject();
        }
    });
}

const getShowPlatesManufacturer = (($http, filter) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/manufacturer/slug/" + filter, headersObj)
            .then((response) => {
                resolve(response.data.manufacturer);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getFonts = (($http, manu_id) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/fonts/manufacturer/" + manu_id, headersObj)
            .then((response) => {
                resolve(response.data.fonts);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getShowPlatesModels = (($http, manu_id) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/models/manufacturer/" + manu_id, headersObj)
            .then((response) => {
                resolve(response.data.models);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});


export default {
  name: 'showPlatesModels',
  components: {
      LoadingSpinner: LoadingSpinner,
      cTable,
      ManufacturerForm,
      ModelForm,
      FontForm
  },
  data () {
    return {
        userAuthLevel: '',
        manufacturerInputMode: 'edit',
        modelInputMode: 'add',
        fontInputMode: 'add',
        showManufacturerForm: false,
        manufacturerObj: this.resetManufacturer(),
        manufacturerName: '',
        manufacturerId: 0,
        newModel: this.resetModel(),
        newFont: this.resetFont(),
        addModelMode: false,
        editModelMode: false,
        addFontMode: false,
        editFontMode: false,
        allowSave: false,
        saveError: false,
        saveInProgress: false,
        saveSuccess: false,
        modelsLoaded: false,
        fontsLoaded: false,
        tableFilter: '',
        perPage: 20,
        manufacturers: [],
        fonts: [],
        modelTableFilter: '',
        modelTablePerPage: 20,
        modelTableCurrentPage: 1,
        modelTableTotalRows: 0,
        modelTableFields: [
            {key: 'model_name', label: 'Model', sortable: true},
        ],
        fontTableFilter: '',
        fontTablePerPage: 20,
        fontTableCurrentPage: 1,
        fontTableTotalRows: 0,
        fontTableFields: [
            {key: 'font_name', label: 'Font Name', sortable: true},
            {key: 'font_name_slug', label: 'Font Slug', sortable: true},
        ],
        models: [],
        tabIndex: [0, 0],
        tabs: [
            'Models',
            'Fonts'
        ]
    }
  },
  async created () {
    const manufacturerSlug = this.$route.params.manufacturer;
    
    // get the manufacturer id
    const manuData = await getShowPlatesManufacturer(this.$http, manufacturerSlug);

    this.$data.manufacturerName = manuData.manufacturer_name;

    this.$data.manufacturerObj = {
        id: manuData.id,
        manufacturer_name: manuData.manufacturer_name,
        page_slug: manuData.page_slug,
        font_id: manuData.font_id
    }
    this.$data.showManufacturerForm = true;


    console.log(this.$data.manufacturerObj);

    this.getShowPlatesModels();
    this.getFontList();

  },
  watch: {
  },
  computed: {
    isUserReadOnly() {
        console.log(this.$data.userAuthLevel);
        if (this.$data.userAuthLevel == 'Read Only') {
            return true;
        }
        else {
            return false;
        }
    },
    anyAddMode() {
        let mode = false;
        if (this.$data.addFontMode) {
            mode = true;
        }
        if (this.$data.addModelMode) {
            mode = true;
        }
        return mode;
    }
  },
  methods : {
    closeManufacturerForm() {
        this.$router.go(-1);
    },
    closeModelForm() {
        this.exitAddModelMode();
    },
    closeFontForm() {
        this.exitAddFontMode();
    },
    resetManufacturer() {
      return {
        id: 0,
        manufacturer_name: "",
        page_slug: "",
        font_id: 0
      }
    },
    resetModel() {
      return {
        id: 0,
        model_name: "",
        manufacturer_name: "",
        manufacturer_id: 0
      }
    },
    resetFont() {
      return {
        id: 0,
        font_name: "",
        font_name_slug: "",
        manufacturer_id: 0
      }
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    modelRowSelected(item, index) {

        let user = JSON.parse(localStorage.getItem('user'));
        if(user === null) {
          return;
        }
        if(typeof user.auth === 'undefined'){
          return;
        }
        // grab the model. We already have the data in the array
        let model = this.$data.models.filter((modelObj) => {
            return modelObj.id == item.id;
        })[0];
        
        this.$router.push(`/show-plates/${this.$data.manufacturerObj.page_slug}/${model.page_slug}`);


    },
    fontRowSelected(item, index) {

        let user = JSON.parse(localStorage.getItem('user'));
        if(user === null) {
          return;
        }
        if(typeof user.auth === 'undefined'){
          return;
        }
        // grab the model. We already have the data in the array
        let model = this.$data.models.filter((modelObj) => {
            return modelObj.id == item.id;
        })[0];
        
        this.$router.push(`/show-plates/${this.$data.manufacturerObj.page_slug}/${model.page_slug}`);


    },
    getHTTPHeaders() {
      let userObj = JSON.parse(localStorage.getItem('user'));
      return {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
          }
        };
    },
    async getFontList() {
        const fonts = await getFonts(this.$http, this.$data.manufacturerObj.id);
        this.$data.fontsLoaded = true;
        this.$data.fonts = fonts.map((font) => {
            if (font.is_active == 1) {
                font.isIncluded = true;
            }
            else {
                font.isIncluded = false;
            }
            return font;
        });
    },
    async getShowPlatesModels() {
        const models = await getShowPlatesModels(this.$http, this.$data.manufacturerObj.id);
        this.$data.modelsLoaded = true;
        this.$data.models = models;
        this.$data.modelTableTotalRows = models.length;
        console.log("PerPage: " + this.$data.modelTablePerPage);
        console.log(models.length);
    },
    exitAddModelMode() {
        this.$data.addModelMode = false;
        this.$data.showManufacturerForm = true;
        this.$data.editMode = false;
        this.$data.saveSuccess = false;
        this.$data.fontsLoaded = false;
        this.$data.modelsLoaded = false;
        this.getShowPlatesModels();
        this.getFontList();
    },
    exitAddFontMode() {
        console.log("Leaving add font mode...");
        this.$data.addFontMode = false;
        this.$data.showManufacturerForm = true;
        this.$data.editMode = false;
        this.$data.saveSuccess = false;
        this.$data.fontsLoaded = false;
        this.$data.modelsLoaded = false;
        this.getShowPlatesModels();
        this.getFontList(); 
    },
    // exitEditMode() {
    //     this.$data.addMode = false;
    //     this.$data.editMode = false;
    //     this.$data.saveSuccess = false;
    //     this.$data.manufacturersLoaded = false;
    //     this.$data.fontsLoaded = false;
    //     this.$data.modelsLoaded = false;
    //     this.getModels();
    // },
    enterAddModelMode() {
        this.$data.newModel = this.resetModel();
        this.$data.newModel.manufacturer_name = this.$data.manufacturerName;
        this.$data.newModel.manufacturer_id = this.$data.manufacturerObj.id;
        this.$data.addModelMode = true;
        this.$data.showManufacturerForm = false;
    },
    enterAddFontMode() {
        this.$data.newFont = this.resetFont();
        this.$data.newFont.manufacturer_name = this.$data.manufacturerName;
        this.$data.newFont.manufacturer_id = this.$data.manufacturerObj.id;
        this.$data.addFontMode = true;
        this.$data.showManufacturerForm = false;
    },
    enterEditModelMode() {
      this.$data.addModelMode = false;
      this.$data.editMode = true;
      this.$data.allowSave = true;
      //this.getShowPlatesModels();
    },
    enterEditFontMode() {
      this.$data.addFontMode = false;
      this.$data.editFontMode = true;
      this.$data.allowSave = true;
      //this.getShowPlatesModels();
    },
    clearAlerts() {
        this.$data.saveError = false;
        this.$data.saveInProgress = false;
    },
    saveModel() {
        this.clearAlerts();
        this.$data.saveInProgress = true;
        let headersObj = this.getHTTPHeaders();

        let url = 'showPlatesModel'
        if(typeof this.$data.newModel.id !== undefined && this.$data.newModel.id > 0) {
          url+= '/' + this.$data.newModel.id;
        }

        let dataPostObject = {
            model_name: this.$data.newModel.model_name,
            manufacturer_id: this.$data.manufacturerId
        }

        this.$http.post(url, dataPostObject, headersObj)
        .then((response) => {
            console.log(response.data);
            if (response.data.success == true) {
                this.$data.saveInProgress = false;
                this.$data.saveError = false;
                this.$data.saveSuccess = true;
                this.exitAddMode();
                this.$router.push('show-plates');
            }
            else {
                // data error
                this.$data.saveInProgress = false;
                this.$data.saveError = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.saveInProgress = false;
            this.$data.saveError = true;
        });
    },
    addModel() {
       this.enterAddModelMode();
    },
    addFont() {
       this.enterAddFontMode();
    },
    async fontSelected(font) {
        console.log('font: ', font);
        let headersObj = this.getHTTPHeaders();

        let url = 'toggleShowplateFont';

        let dataPostObject = {
            font_id: font.id,
            is_active: font.isIncluded == true ? 1 : 0
        };

        const response = await this.$http.post(url, dataPostObject, headersObj);
        if (response.data.success == true) {
            await this.getFontList();
        }
    }
  }
}
</script>

<style scoped>
    .row.output-row {
        padding-bottom: 8px;
    }
</style>
